<template>
    <div class="todo-list-page h100">
        <van-search
            v-model="filter.filter"
            placeholder="请输入搜索关键词"
            @search="onSearch"
        />
        <van-tabs v-model="active" @change="changeTabs">
            <van-tab
                v-for="(item, index) in type"
                :key="item.label"
                :title="item.label"
            >
                <base-list
                    :ref="`baseList${index}`"
                    :api="getApi"
                    :filter="{ ...item.filter, ...filter }"
                >
                    <template v-slot:default="scope">
                        <todo-item :data="scope.data" @handleClick="handleClick" />
                    </template>
                </base-list>
            </van-tab>
            <!-- <van-tab title="货物">
                <base-list ref="baseList2" :api="getApi" :filter="filter">
                    <template v-slot:default="scope">
                        <todo-item :data="scope.data" @handleClick="handleClick" />
                    </template>
                </base-list>
            </van-tab> -->
        </van-tabs>
        <div class="filter" @click="showFilter = true">
            <img src="../../assets/icon/ICON-筛选@2x.png">
            <span>筛选</span>
        </div>
        <van-popup v-model="showFilter" position="right" class="filter-bar h100">
            <div class="title">
                <span>筛选</span>
            </div>
            <div class="sub-title">
                <span>事项类型</span>
            </div>
            <div class="todo-list-page-radio zlm-radio">
                <van-radio-group v-model="filter.todoTypeValue" direction="horizontal">
                    <van-radio
                        v-for="item in todoType"
                        :key="item.value"
                        :name="item.value"
                        icon-size="14px"
                    >{{ item.label }}</van-radio>
                </van-radio-group>
            </div>
            <div class="sub-title">
                <span>项目类型</span>
            </div>
            <div class="todo-list-page-radio zlm-radio">
                <van-radio-group
                    v-model="filter.projectTypeValue"
                    direction="horizontal"
                    @change="changeProType"
                >
                    <van-radio
                        v-for="item in projectType"
                        :key="item.value"
                        :name="item.value"
                        icon-size="14px"
                    >{{ item.label }}</van-radio>
                </van-radio-group>
            </div>
            <div class="footer-btn">
                <van-button round @click="resetFilter">重置</van-button>
                <van-button round type="primary" @click="onSearch">确定</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import { Search, RadioGroup, Radio, Tab, Tabs, Popup, Button } from 'vant'
    const {
        projectType,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/projectType`)
    const {
        todoType,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/todoType`)
    const {
        todoApi,
        mixin,
        type,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/todo`)
    import baseList from '@/components/baseList'
    import todoItem from '@/components/todoItem'

    export default {
        name: 'TodoList',
        components: {
            [Search.name]: Search,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Popup.name]: Popup,
            [Button.name]: Button,
            baseList,
            todoItem,
        },
        mixins: [mixin],
        data() {
            return {
                showFilter: false,
                active: 0,
                filter: {
                    projectTypeValue: 0,
                },
                projectType,
                todoType,
                getApi: todoApi,
                type,
            }
        },
        methods: {
            changeTabs(name) {
                this.filter.projectTypeValue = name
            },
            changeProType(name) {
                this.active = name
            },
            resetFilter() {
                this.filter = {}
            },
            onSearch() {
                this.showFilter = false
                this.$refs[`baseList${this.active}`][0].refresh()
            },
            handleClick(item) {
                const exist = todoType.find(
                    (t) => t.value.toString() === item.type.toString(),
                )
                this.$router.push({
                    name: 'TodoDetail',
                    query: {
                        title: exist ? exist.label : '',
                        target: exist ? exist.target : '',
                        id: item.id,
                    },
                })
            },
        },
    }
</script>

<style lang="scss">
.todo-list-page {
  background: url("../../assets/images/project/sekuiai5.png") no-repeat;
  background-position: 0px -90px;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .van-search {
    background: none;
  }
  .van-tab--active {
    font-weight: bold;
    color: #00923f;
  }
  .van-tabs__nav {
    font-weight: bold;
    padding-left: 20px;
  }
  .van-tabs {
    border-radius: 10px 10px 0 0;
    background: #ffffff;
    flex: 1;
    .van-tabs__wrap {
      border-radius: 10px 10px 0 0;
    }
  }
  .van-tab {
    flex: 0 0 auto !important;
    padding: 0px 10px;
  }
  .van-tabs__line {
    background-color: rgba(0, 146, 63, 1) !important;
    height: 2px !important;
  }
  .filter-btn-area {
    font-size: 13px;
    line-height: 40px;
    text-align: center;
    border-top: 1px solid rgba(221, 221, 221, 1);
    &-left {
      border-right: 1px solid rgba(221, 221, 221, 1);
    }
  }
  &-radio {
    padding: 20px 10px 10px 12px;
    box-sizing: border-box;
    height: 40vh;
    overflow: auto;
  }
  .filter {
    position: absolute;
    color: #02b38a;
    right: 10px;
    top: 65px;
    font-size: 14px;
    img {
      width: 15px;
      margin-right: 5px;
    }
  }
  .filter-bar {
    width: 266px;
    // position: relative;
    .title {
      font-weight: bold;
      font-size: 16px;
      padding-top: 30px;
      padding-left: 20px;
      color: #333333;
    }
    .sub-title {
      font-size: 14px;
      padding-top: 20px;
      padding-left: 20px;
    }
    .zlm-radio .van-radio[aria-checked="true"] {
      border: 0.02667rem solid #02b38a;
    }
    .zlm-radio .van-radio .van-radio__icon--checked + .van-radio__label {
      color: #02b38a;
    }
    .van-radio__icon--checked .van-icon {
      background-color: #02b38a;
    }
    .zlm-radio .van-radio {
      border-radius: 3px;
      background: #f2f2f2;
    }
    .footer-btn {
      position: absolute;
      left: 0;
      bottom: 20px;
      width: 100%;
      text-align: center;
      .van-button {
        height: 37px;
        width: 110px;
        // padding: 0 25px;
        margin: 0 7px;
      }
      .van-button--primary {
        background-color: #02b38a;
        border: 0.02667rem solid #02b38a;
      }
    }
  }
}
</style>
